// extracted by mini-css-extract-plugin
export var button = "time-machine-module--button--120cf";
export var chevron = "time-machine-module--chevron--81053";
export var item = "time-machine-module--item--79cb0";
export var link = "time-machine-module--link--bcf45";
export var nav = "time-machine-module--nav--86640";
export var timeMachine = "time-machine-module--timeMachine--fba0b";